"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSignedAppReleaseGrant = isSignedAppReleaseGrant;
exports.isAppReleaseSnapshotPayload = isAppReleaseSnapshotPayload;
/**
 * Wire contract of the signed App release confirmation: which published App
 * release one session may run. Signed like the permission snapshot; its
 * validity is the envelope's `expiresAt`.
 */
const contract_1 = require("./contract");
function isStringList(value) {
    return Array.isArray(value) && value.every(contract_1.isNonEmptyString);
}
function isAppReleasePrincipal(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const principal = value;
    switch (principal.type) {
        case 'workspace-member':
            return (0, contract_1.isNonEmptyString)(principal.userId);
        case 'portal-member':
            return ((0, contract_1.isNonEmptyString)(principal.portalIdentityId) &&
                (0, contract_1.isNonEmptyString)(principal.appBaseId));
        case 'public':
            return (0, contract_1.isNonEmptyString)(principal.appBaseId);
        default:
            return false;
    }
}
function isSignedAppReleaseGrant(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const grant = value;
    return ((0, contract_1.isNonEmptyString)(grant.appBaseId) &&
        (0, contract_1.isNonEmptyString)(grant.manifestId) &&
        Number.isInteger(grant.releaseVersion) &&
        (0, contract_1.isNonEmptyString)(grant.artifactDigest) &&
        (0, contract_1.isNonEmptyString)(grant.manifestDigest) &&
        Array.isArray(grant.sourceKeys) &&
        grant.sourceKeys.every(contract_1.isNonEmptyString) &&
        isStringList(grant.origins) &&
        grant.origins.length > 0);
}
function isAppReleaseSnapshotPayload(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const payload = value;
    return (payload.version === 1 &&
        payload.subjectType === 'app-release-snapshot' &&
        (0, contract_1.isNonEmptyString)(payload.tenantId) &&
        (0, contract_1.isNonEmptyString)(payload.workspaceId) &&
        (0, contract_1.isNonEmptyString)(payload.serverId) &&
        (0, contract_1.isNonEmptyString)(payload.serverBaseUrlHash) &&
        isAppReleasePrincipal(payload.principal) &&
        Array.isArray(payload.grants) &&
        payload.grants.every(isSignedAppReleaseGrant));
}
//# sourceMappingURL=app-release.js.map